import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=36857550&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style1 from "./Home.vue?vue&type=style&index=1&id=36857550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36857550",
  null
  
)

export default component.exports